
import uiMixin from '@/mixins/uiMixin';

export default {
  mixins: [uiMixin],
  name: 'FAQView',
  data() {
    return {
      isLoaded: false,
    };
  },

  props: {
    title: {
      required: true,
      type: String,
    },
    subtitle: {
      required: true,
      type: String,
      default: null,
    },
    list: {
      required: true,
      type: Array,
    },
  },

  mounted() {
    this.isLoaded = true;
  },
};
